import React from "react";
import "./hero.css";
import Info from "../Images/Info.png";
import Logo from '../Images/Logo.png';

export default function Hero() {
  return (
    <section className="zm-hero" id="home">
      <div className="zm-container zm-hero-inner">
        <div className="hero-copy">
          <p className="eyebrow">ZeitaMax</p>
          <h1 className="headline">Connecting Potential Without Limits</h1>
          <p className="sub">
            Powering businesses with exceptional technology talent. We help
            organizations build high-performing IT teams that accelerate growth,
            enable digital transformation, and deliver measurable results.
          </p>
          <div className="hero-ctas">
            <a className="btn primary" href="#services">
              Hire Top Talent
            </a>
            <a className="btn ghost" href="#careers">
              Explore Careers
            </a>
          </div>
          <p className="hero-note">
            Hire Faster. Scale Smarter. Grow Stronger.
          </p>
        </div>
        <div className="hero-visual" aria-hidden="true">
          <div className="talent-orbit">
            <span className="orbit-ring orbit-ring-outer" />
            <span className="orbit-ring orbit-ring-inner" />
            <span className="orbit-path orbit-path-one" />
            <span className="orbit-path orbit-path-two" />

            <div className="orbit-core">
              <img className="core-logo" src={Logo} alt="" />
            </div>

            <div className="talent-node talent-node-dev">
              <span>&lt;/&gt;</span>
              <b>Tech talent</b>
            </div>
            <div className="talent-node talent-node-data">
              <span>↗</span>
              <b>Growth</b>
            </div>
            <div className="talent-node talent-node-cloud">
              <span>✓</span>
              <b>Results</b>
            </div>
            <div className="talent-node talent-node-design">
              <span>✦</span>
              <b>Digital</b>
            </div>

            <span className="match-pill"><i /> Potential connected</span>
          </div>
        </div>
      </div>
    </section>
  );
}
